<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.update') }}</h4>
        </div>
        <section class="col-12 mx-auto align-self-md-center">
            <div class="half-design row">
                <div class="col-12 form-block">
                    <div class="col-12 col-md-6 col-lg-5 mx-auto pt-5">

                        <b-form @submit.prevent="onSubmit">
                            <!-- name  -->
                            <div class="mb-3 text-left">
                                <label for="fullName" class="mb-1" :class="fullNameState">
                                    {{ $t('title.full_name') }}
                                </label>
                                <b-form-input id="fullName" type="text" v-model="formFields.full_name"
                                    :placeholder="$t('title.full_name')" @input="validateFullName"
                                    :class="fullNameState"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('full_name')">
                                    {{ formErrors.first('full_name') }}
                                </b-form-invalid-feedback>
                            </div>

                            <!-- email  -->
                            <div class="mb-3 text-left">
                                <label for="email" class="mb-1" :class="emailState">
                                    {{ $t('title.email') }}
                                </label>
                                <b-form-input id="email" type="text" v-model="formFields.email"
                                    :placeholder="$t('title.email')" @input="validateEmail"
                                    :class="emailState"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('email')">
                                    {{ formErrors.first('email') }}
                                </b-form-invalid-feedback>
                            </div>

                            <!-- phone no  -->
                            <div class="mb-3 text-left">
                                <label for="phone" class="mb-1" :class="phoneState">
                                    {{ $t('title.phone') }}
                                </label>
                                <b-form-input id="phone" type="text" v-model="formFields.phone"
                                    :placeholder="$t('title.phone')" @input="validatePhone"
                                    :class="phoneState"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('phone')">
                                    {{ formErrors.first('phone') }}
                                </b-form-invalid-feedback>
                            </div>

                            <!-- status  -->
                            <div class="mb-3 text-left">
                                <label for="status" class="mb-1" :class="statusState">
                                    {{ $t('title.SelectStatus') }}
                                </label>
                                <v-select id="status" v-model="formFields.status" :class="statusState"
                                    :options="statusOptions" size="sm" required></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('status')">
                                    {{ formErrors.first('status') }}
                                </b-form-invalid-feedback>
                            </div>
                            <!-- Role -->
                            <div class="mb-3 text-left">
                                <label for="role" class="mb-1" :class="roleState">
                                    {{ $t('title.SelectRole') }}
                                </label>
                                <v-select id="role" v-model="formFields.role" :class="roleState" :options="roleOptions"
                                    size="sm" required></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('role')">
                                    {{ formErrors.first('role') }}
                                </b-form-invalid-feedback>
                            </div>

                            <b-button type="submit" variant="primary" class="mb-3 w-100" :disabled="loader">
                                <div class="spinner-border spinner-border-sm text-light" role="status" v-if="loader">
                                </div>
                                {{ $t('title.Submit') }}
                            </b-button>

                            <a class="text-center d-block mb-1" href="#" @click.prevent="onCancel">
                                {{ $t('title.Cancel') }}
                            </a>

                            <b-form-invalid-feedback v-if="formErrors.general">
                                {{ formErrors.general }}
                            </b-form-invalid-feedback>
                        </b-form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import { request } from "@/Util/Request";
import Error from "@/Util/Error";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
    data() {
        return {
            formFields: reactive({
                fullName: '',
                email: '',
                phone: '',
                status: null,
                role: null,
            }),
            statusOptions: [
                { label: this.$t('title.Active'), value: '1' },
                { label: this.$t('title.Inactive'), value: '0' },
            ],
            roleOptions: [
                { label: this.$t('title.Admin'), value: 'admin' },
                { label: this.$t('title.User'), value: 'user' },
            ],
            formErrors: new Error({}),
        };
    },
    components: { Breadcrumbs },
    computed: {
        ...mapGetters(['loader']),
        fullNameState() {
            return this.formFields.fullName === '' ? '' : this.formErrors.$errors.fullName ? 'is-invalid' : 'is-valid';
        },
        roleState() {
            return this.formFields.role === null ? '' : this.formErrors.$errors.role ? 'is-invalid' : 'is-valid';
        },

        emailState() {
            return this.formFields.email === '' ? '' : this.formErrors.$errors.email ? 'is-invalid' : 'is-valid';
        },
        phoneState() {
            return this.formFields.phone === '' ? '' : this.formErrors.$errors.phone ? 'is-invalid' : 'is-valid';
        },
        statusState() {
            return this.formFields.status === null ? '' : this.formErrors.status ? 'is-invalid' : 'is-valid'; // Add computed for status
        },
        passwordState() {
            if (!this.formFields.password) return ''; // Empty field, no validation state
            return this.formErrors.has('password') ? 'is-invalid' : 'is-valid';
        },
        passwordConfirmState() {
            if (!this.formFields.password_confirmation) return ''; // Empty field, no validation state
            return this.formErrors.has('password_confirmation') ? 'is-invalid' : 'is-valid';
        }
    },

    methods: {
        validateRole() {
            if (!this.formFields.role) {
                this.formErrors.$errors.role = [this.$t('title.roleRequired')];
            } else {
                delete this.formErrors.$errors.role;
            }
        },
        async fetchTaskData(id) {
            try {
                const response = await request({ method: 'get', url: `/admin/system-users/${this.TaskId}` });
                const data = response.data;
                localStorage.setItem('taskData', JSON.stringify(data))
                this.formFields.full_name = data.full_name || "";
                this.formFields.email = data.email || "";
                this.formFields.phone = data.phone || "";
                this.formFields.status = data.is_active ? "Active" : "InActive" || "";
                this.formFields.role = this.roleOptions.find(role => role.value === data.roles) || null;
            } catch (error) {
                console.error('Error fetching Task data:', error);
            }
        },

        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        toggleConfirmPasswordVisibility() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        validatePassword() {
            if (!this.formFields.password) {
                this.formErrors.password = [this.$t('title.passwordRequired')];
            } else if (this.formFields.password.length < 8) {
                this.formErrors.$errors.password = [this.$t('title.passwordMinLength')];
            } else {
                delete this.formErrors.$errors.password;
            }

            if (this.formFields.password_confirmation !== this.formFields.password) {
                this.formErrors.$errors.password_confirmation = [this.$t('title.passwordMismatch')];
            } else {
                delete this.formErrors.$errors.password_confirmation;
            }
        },
        validateStatus() {
            const status = this.formFields.status;
            if (!status) {
                this.formErrors.$errors.status = [this.$t('title.statusRequired')]; // Add custom error for status
            } else {
                delete this.formErrors.$errors.status;
            }
        },

        validateFullName() {
            const fullName = this.formFields.fullName;
            if (typeof fullName !== 'string') {
                this.formErrors.$errors.fullName = [this.$t('title.organizationNameRequired')];
                return;
            } else {
                delete this.formErrors.$errors.fullName;
            }
        },

        validateEmail() {
            const email = this.formFields.email;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            // Clear previous errors
            this.formErrors.$errors.email = [];

            if (!email) {
                this.formErrors.$errors.email = [this.$t('title.emailRequired')]; // Email is required
            } else if (!emailRegex.test(email)) {
                this.formErrors.$errors.email = [this.$t('title.invalidEmail')]; // Invalid email format
            } else {
                delete this.formErrors.$errors.email;
            }
        },

        validatePhone() {
            const phone = this.formFields.phone;
            const phoneRegex = /^[0-9]{7,15}$/;

            // Clear previous errors
            this.formErrors.$errors.phone = [];

            if (!phone) {
                this.formErrors.$errors.phone = [this.$t('title.phoneRequired')]; // Phone number is required
            } else if (!phoneRegex.test(phone)) {
                this.formErrors.$errors.phone = [this.$t('title.invalidPhone')]; // Invalid phone number
            } else {
                delete this.formErrors.$errors.phone;
            }
        },


        reloadPage() {
            this.$router.push({ name: 'Users' });
        },

        async onSubmit() {

            const payload = {
                full_name: this.formFields.full_name,
                email: this.formFields.email,
                phone: this.formFields.phone,
                is_active: this.formFields.status.label === "Inactive" ? 0 : 1,
                role: this.formFields.role.value

            };
            try {
                const response = await request({
                    method: 'put',
                    url: `admin/system-users/${this.TaskId}`,
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json',   // Content type for JSON data
                    }
                });

                const data = response;
                if (response['message'] && response['message'].includes("successfull") || response['code'] == 200) {
                    this.showToast();
                    setTimeout(() => {
                        this.reloadPage();
                    }, 1500);
                } else {
                    throw new Error(data.message || 'Error submitting form');
                }
            } catch (error) {
                this.formErrors = new Error({});

                if (error?.data?.errors) {
                    const errors = error.data.errors;
                    this.formErrors.$errors.name = errors.name ? errors.name : '';
                    this.formErrors.$errors.typeSelect = errors.scheduled_type ? errors.scheduled_type : '';
                    this.formErrors.$errors.start_time = errors.start_time ? errors.start_time : '';
                    this.formErrors.$errors.general = "Please fix the errors and try again.";
                    return false;

                } else {

                    this.formErrors.general = "Something went wrong. Please try again.";
                }
            }
        },

        showToast() {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
                this.$t('title.dataUpdated')
            ]);
            // Create the title
            const vNodesTitle = h(
                'div',
                { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, this.$t('title.dataUpdatedTitle'))]
            );
            // Pass the VNodes as an array for message and title
            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: 'success',
            });
        },

        onCancel() {
            this.$router.push({ name: 'Users' });
        },
    },



    mounted() {
        const id = this.$route.params.id;
        this.TaskId = id;
        this.fetchTaskData(id);
    },






};
</script>
<style>
.vue__time-picker input.display-time {
    width: 100% !important;
}
</style>
